export const GET_EASYPAY_FORMDATA = 'processes@GET_EASYPAY_FORMDATA';
export const SET_EASYPAY_FORMDATA = 'processes@SET_EASYPAY_FORMDATA';
export const SET_EASYPAY_ONBOARDING_PID = 'processes@SET_EASYPAY_ONBOARDING_PID';
export const POST_EASYPAY_FORMDATA = 'processes@POST_EASYPAY_FORMDATA';

export const getEasypayFormdata = (payload) => ({ type: GET_EASYPAY_FORMDATA, data: payload })
export const setEasypayFormdata = (formdata) => ({ type: SET_EASYPAY_FORMDATA, formdata })
export const setEasypayOnboardingPid = (pid) => ({ type: SET_EASYPAY_ONBOARDING_PID, pid })
export const postEasypayFormData = (formdata, url) => ({ type: POST_EASYPAY_FORMDATA, formdata, url })